"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontStyles = void 0;

var _IRANSansXRegular = _interopRequireDefault(require("./woff/IRANSansX-Regular.woff"));

var _IRANSansXRegular2 = _interopRequireDefault(require("./woff2/IRANSansX-Regular.woff2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import IranSansXWoff from "./woff/IranSansX-regular.woff";
// import IranSansXWoff2 from "./woff2/IranSansX-regular.woff2";
// import IranSansXEot from "./eot/IranSansX-regular.eot";
var fontStyles = {
  // '@font-face': {
  //     fontFamily: "IranSansX",
  //     src: `url(${IranSansXWoff})`,
  //     fallbacks: [
  //       {src: `url(${IranSansXWoff2})`},
  //       {src: `url(${IranSansXEot})`}
  //     ]
  // }
  "@font-face": {
    fontFamily: "IranSansX",
    src: "url(".concat(_IRANSansXRegular["default"], ")"),
    fallbacks: [{
      src: "url(".concat(_IRANSansXRegular2["default"], ")")
    }]
  }
};
exports.fontStyles = fontStyles;